import {Directive, HostListener, Input} from '@angular/core';
import {AbstractControl} from '@angular/forms';

@Directive({
	selector: '[matDatepicker]'
})
export class MatDatepickerValidDateDirective {
	@Input() abstractControl: AbstractControl;

	@HostListener('change')
	onInput(): void {
		if (this.abstractControl && (this.abstractControl.value === null || this.abstractControl.value === '')) {
			this.abstractControl.setValue(null);
		}
	}
}
